/*
 * @Author: tony.zhu
 * @Date: 2024-10-18 15:07:25
 * @LastEditTime: 2024-10-18 15:23:06
 * @LastEditors: tony.zhu
 * @Description: 自定义指令
 */

const constantFiles = require.context('./constant', true, /\.js$/)
let constantDirective = {}
constantFiles.keys().forEach((key) => {
  constantDirective = Object.assign(constantDirective, constantFiles(key).default)
})

export default constantDirective